import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getPeticiones,
  deletePeticion,
  changeStatusPeticion,
} from "../../../../api/peticion";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { Visibility } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import { getClientes } from "../../../../api/cliente";
import { getCotizaciones } from "../../../../api/cotizacion";
import { getPaises } from "../../../../api/pais";
import { generarOfertaVehiculo } from "../../../../api/companyConnection";
import FiltersCard from "../../../components/filters/Filter";
import { Autocomplete } from "@material-ui/lab";
import { getModalidades } from "../../../../api/modalidad";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import ImageCarouselDialog from "../../../components/dialogs/ImageCarouselDialog";

function getData(peticiones, clientes, cotizaciones, paises) {
  let data = [];
  for (let i = 0; i < peticiones.length; ++i) {
    const peticion = peticiones[i];
    const cliente = clientes?.find((x) => x._id === peticion?.cliente);
    const { caser, generali, zurich, marca, modelo, version } =
      cotizaciones.find((x) => x?.peticion === peticion?._id) || {};
    const elem = {};
    elem.coti_caser = caser;
    elem.coti_generali = generali;
    elem.coti_zurich = zurich;
    elem.cliente_name = [cliente?.nombre, cliente?.apellido1]
      .filter(Boolean)
      .join(" ");
    elem.cliente_email = cliente?.email;
    elem.cliente_tel = cliente?.tel;
    elem.nacionalidad = paises?.find(
      (x) => x.code === cliente?.nacionalidad,
    )?.name;
    elem.vehiculo_type = peticion?.coche ? "Coche" : "Moto";
    elem.vehiculo_modelo = [marca, modelo].filter(Boolean).join(" ");
    elem.vehiculo_version = version || "";
    elem.createdAt = peticion?.createdAt;
    elem.estado = peticion?.estado;
    elem.id = peticion?._id;
    elem.active = peticion?.active;
    data = data.concat(elem);
  }
  return data;
}

const initialFilters = { estado: [], paises: [] };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: () => null,
};

export default function PeticionesPage() {
  const [data, setData] = useState([]);
  const [modalidadesPropias, setMoadlidadesPropias] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [cotizaciones, setCotizaciones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [paises, setPaises] = useState([]);
  const [fileUrls, setfileUrls] = useState([]);
  const [peticionId, setPeticionId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    const listaPDF = [];
    if (elem?.urlPDF) listaPDF.push(elem.urlPDF);
    if (elem?.urlCaser) listaPDF.push(elem.urlCaser);
    if (elem?.urlGenerali) listaPDF.push(elem.urlGenerali);
    if (elem?.urlZurich) listaPDF.push(elem.urlZurich);
    return (
      <>
        <Tooltip title="Ver Cotizaciones">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setPeticionId(cell);
              setOpenDialog(true);
              setfileUrls(listaPDF);
            }}
          >
            <Visibility />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setPeticionId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Eliminar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setPeticionId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "cliente_name", text: "Nombre", sort: true },
    { dataField: "cliente_email", text: "Email", sort: true },
    { dataField: "cliente_tel", text: "Teléfono", sort: true },
    { dataField: "nacionalidad", text: "Nacionalidad", sort: true },
    { dataField: "vehiculo_type", text: "Vehiculo", sort: true },
    { dataField: "vehiculo_modelo", text: "Marca / Modelo", sort: true },
    { dataField: "vehiculo_version", text: "Versión", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha de creación",
      formatter: dateFormatter,
      sort: true,
    },
    { dataField: "estado", text: "Estado", sort: true },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: () => {
        return { width: "160px", textAlign: "center" };
      },
    },
  ];

  useEffect(() => {
    getModalidades()
      .then((res) => {
        if (res.status === 200) {
          setMoadlidadesPropias(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las modalidades propias.",
        });
      });
    getPaises()
      .then((res) => {
        if (res.status === 200) {
          setPaises(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las peticiones.",
        });
      });
    getClientes()
      .then((res) => {
        if (res.status === 200) {
          setClientes(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las peticiones.",
        });
      });
    getCotizaciones()
      .then((res) => {
        if (res.status === 200) {
          setCotizaciones(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las peticiones.",
        });
      });
    getPeticiones()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las peticiones.",
        });
      });
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    let dataFiltered = data;
    if (filterOptions?.estado?.length > 0) {
      dataFiltered = dataFiltered.filter((x) =>
        filterOptions.estado.includes(x.estado),
      );
    }
    if (filterOptions?.paises?.length > 0) {
      const codePaises = filterOptions.paises.map((x) => x.code);
      dataFiltered = dataFiltered.filter((x) =>
        codePaises.includes(
          clientes?.find((y) => y._id === x?.cliente)?.nacionalidad,
        ),
      );
    }

    if (filterOptions?.vehiculo?.length === 1) {
      dataFiltered = dataFiltered.filter((x) =>
        filterOptions.vehiculo[0] === "coche" ? x.coche : !x.coche,
      );
    }

    setFilteredData(dataFiltered);
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <>
        <div className="d-flex align-items-center">
          <div className="col-md-4">
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-standard-label">
                Estado de la petición
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={filterOptions.estado || []}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    estado: event.target.value,
                  });
                }}
                MenuProps={MenuProps}
                multiple
              >
                <MenuItem key={"0"} value={"pendiente cotizacion"}>
                  Pendiente de cotizar
                </MenuItem>
                <MenuItem key={"1"} value={"cotizado"}>
                  Cotizado
                </MenuItem>
                <MenuItem key={"2"} value={"enviado"}>
                  Enviado
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-standard-label">
                Tipo de vehículo
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={filterOptions.vehiculo || []}
                onChange={(event) => {
                  setFilterOptions({
                    ...filterOptions,
                    vehiculo: event.target.value,
                  });
                }}
                MenuProps={MenuProps}
                multiple
              >
                <MenuItem key={"0"} value={"coche"}>
                  Coches
                </MenuItem>
                <MenuItem key={"1"} value={"moto"}>
                  Motos
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-md-4">
            <Autocomplete
              className="w-100 mr-5"
              multiple
              id="autocomplete-paises"
              filterSelectedOptions
              options={paises}
              getOptionLabel={(option) => option?.name}
              value={filterOptions.paises || []}
              onChange={(event, selected) => {
                setFilterOptions({
                  ...filterOptions,
                  paises: selected,
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Nacionalidades"
                />
              )}
            />
          </div>
        </div>
        <br />
        <br />
      </>
    );
  };

  const handleEnviar = async (listaModalidades, url) => {
    try {
      const respuesta = await generarOfertaVehiculo({
        peticion: peticionId,
        listaModalidades,
        url,
      });
      alertSuccess({ customMessage: "Oferta enviada" });
      setRefresh(true);
    } catch (error) {
      alertError({ customMessage: "Ha ocurrido un error" });
    }
  };

  return (
    <>
      <Card>
        <CardHeader title="Peticiones list"></CardHeader>
        <CardBody>
          <FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />
          <Table
            search={true}
            data={getData(filteredData, clientes, cotizaciones, paises)}
            columns={columns}
          />
          <ConfirmDialog
            title={`¿Estás seguro de que quieres ${
              peticionId?.active ? "desactivar" : "activar"
            } esta peticion?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusPeticion(peticionId.id, !peticionId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        peticionId?.active ? "¡Desactivada!" : "¡Activada!"
                      }`,
                      customMessage: `Peticion ${
                        peticionId?.active ? "desactivada" : "activada"
                      } correctamente`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `No se ha podido ${
                      peticionId?.active ? "desactivar" : "activar"
                    } esta peticion.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar esta peticion?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deletePeticion(peticionId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "¡Eliminada!",
                      customMessage: "Peticion eliminada correctamente.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la peticion.",
                  });
                });
            }}
          />
          <ImageCarouselDialog
            open={openDialog}
            images={fileUrls}
            setOpen={setOpenDialog}
          />
        </CardBody>
      </Card>
    </>
  );
}
